import UIDs from "../../../../../UIDs";

const uid = UIDs.screens.admin.messageboard.list;

const ActionTypes = {
    LOAD_SCREEN_VIEW_ASYNC: `${uid}.loadScreenViewAsync`,
    LOAD_SCREEN_VIEW_SUCCESS: `${uid}.loadScreenViewSuccess`,
    LOAD_SCREEN_VIEW_FAILURE: `${uid}.loadScreenViewFailure`,
    UPDATE_FILTER_BY: `${uid}.updateFilterBy`,
    DELETE_ASYNC: `${uid}.deleteAsync`,
    DELETE_SUCCESS: `${uid}.deleteSuccess`,
    DELETE_FAILURE: `${uid}.deleteFailure`,
};

export { ActionTypes };
